export default __webpack_public_path__ + "static/image 4-801609cd109b1455e63e922f3cb0bfad.jpeg";